<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      v-model="filterModel"
      :filters="filtersConfig"
      :display-advanced="false"
      class="search-bar"
      search-text="Procesar"
      search-icon="fa fa-sync"
      search-container-class="d-flex align-items-center justify-content-end"
      :is-advanced="false"
      @search="onProcessHandler"
    />
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

//services
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'EquitativeServices',
  components: {
    PageHeader,
    FilterManager,
  },
  mixins: [alertMixin],
  data: () => ({
    filterOptions: {
      academicYears: [],
    },
    filterModel: {
      academicYear: null,
    },
  }),
  computed: {
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Servicios Equitativos',
        routes: ['Inicio', 'Reportes', 'Servicios Equitativos'],
      };
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-3',
          value: this.filterModel.academicYear,
          options: this.filterOptions.academicYears,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      const { data } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.filterOptions.academicYears = data;
      this.filterModel.academicYear = data.find(x => x.selected);
    },
    async onProcessHandler() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      
      const res = await ReportServices.getReport('equitativeservices', {
        academicYearId: this.filterModel.academicYear.id,
      });

      DocumentServices.Download(res.data)
    },
  },
};
</script>
